import { v4 } from 'uuid';

const verticalMenues = [
  {
    id: v4(),
    displayName: 'Företaget',
    formattedName: "menu.enterprise",
    items: [
      { 
        id: v4(),
        displayName: 'Om Julius Biljettservice',
        formattedName: "menu.about",
        localPath: '/information/om', 
      },
      { 
        id: v4(),
        displayName: 'Callcenter',
        formattedName: "menu.customerservice",
        localPath: '/information/callcenter', 
      },
      { 
        id: v4(),
        displayName: 'Grupp- och företagsbokning', 
        formattedName: "menu.bookings",
        localPath: '/gruppbokning', 
      },
      { 
        id: v4(),
        displayName: 'Frågor och svar',
        formattedName: "menu.faq",
        localPath: '/information/faq',
      },
      { 
        id: v4(),
        displayName: 'Våra ombud', 
        formattedName: "menu.agents",
        localPath: '/ombud',
      },
    ],
  },
  {
    id: v4(),
    displayName: 'Arrangemang',
    formattedName: 'menu.arrangements',
    items: [
      { 
        id: v4(),
        displayName: 'Sälj med Julius Biljettservice', 
        formattedName: 'menu.sell',
        localPath: '/arrangör', 
      },
      { 
        id: v4(),
        displayName: 'Musik', 
        formattedName: 'categories.music',
        localPath: '/musik',
      },
      { 
        id: v4(),
        displayName: 'Teater & Underhållning', 
        formattedName: 'categories.theater',
        localPath: '/teater', 
      },
      { 
        id: v4(),
        displayName: 'Familj', 
        formattedName: 'categories.family',
        localPath: '/familj', 
      },
      { 
        id: v4(),
        displayName: 'Sport', 
        formattedName: 'categories.sport',
        localPath: '/sport', 
      },
    ],
  },
  {
    id: v4(),
    displayName: 'Partners',
    formattedName: 'menu.partners',
    items: [
      { 
        id: v4(),
        displayName: 'Julius AB', 
        redirectUrl: 'http://www.juliusab.se/', 
      },
      { 
        id: v4(),
        displayName: 'Julius Production AB', 
        redirectUrl: 'http://juliusproduction.se/', 
      },
      { 
        id: v4(),
        displayName: 'Nöjesteatern', 
        redirectUrl: 'https://www.nojesteatern.se/', 
      },
      { 
        id: v4(),
        displayName: 'Skånetrafiken', 
        redirectUrl: 'https://www.skanetrafiken.se/', 
      },
      { 
        id: v4(),
        displayName: 'Malmö Town', 
        redirectUrl: 'http://www.malmotown.com/', 
      },
    ],
  },
];

const horizontalMenues = [
  // {
  //   id: v4(),
  //   displayName: 'Trygg E-Handel',
  //   formattedName: 'menu.ecommerce',
  //   items: [
  //     { 
  //       id: v4(),
  //       imageUrl: '/e-commerce.png', 
  //     },
  //   ], 
  // },
  {
    id: v4(),
    displayName: 'Sociala Medier',
    formattedName: 'menu.socialmedia',
    items: [
      { 
        id: v4(),
        displayName: 'Facebook', 
        redirectUrl: 'https://www.facebook.com/JuliusBiljettservice/', 
        iconType: 'facebook', 
      },
      { 
        id: v4(),
        displayName: '#juliusproduction',
        redirectUrl: 'https://www.instagram.com/JuliusProduction/', 
        iconType: 'instagram', 
      },
    ],
  },
];

const bottomItems = [
  { 
    id: v4(),
    displayName: 'Köpvillkor', 
    formattedName: 'menu.terms',
    localPath: '/villkor',
  },
  { 
    id: v4(),
    displayName: 'Cookiespolicy', 
    formattedName: 'menu.cookies',
    localPath: '/villkor',
  },
  { 
    id: v4(),
    displayName: '© 2018 Julius Biljettservice AB. All rights reserved.',
    formattedName: 'menu.copyright',
    localPath: '',
  },
];

export const staticContent = {
  verticalMenues,
  horizontalMenues,
  bottomItems,
};


// WEBPACK FOOTER //
// ./src/components/MenuFooter/MenuFooterContent.tsx